export default __webpack_public_path__ + "static/media/19 - Splashin.e7664b87.jpg";